import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

export function useClassRole() {
  const { currentUser } = useAuth();
  const [isClassAdmin, setIsClassAdmin] = useState(false);
  const [classInfo, setClassInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkClassRole = async () => {
      if (!currentUser) {
        setIsClassAdmin(false);
        setClassInfo(null);
        setLoading(false);
        return;
      }

      try {
        // Get user document to check class role
        const userDoc = await getDoc(doc(db, 'users', currentUser.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          const adminStatus = userData.classRole === 'admin';
          setIsClassAdmin(adminStatus);
          
          if (userData.classID) {
            setClassInfo({
              classID: userData.classID,
              className: userData.classSelection,
              role: userData.classRole || 'member'
            });
          }
        }
      } catch (error) {
        console.error('Error checking class role:', error);
        setIsClassAdmin(false);
      } finally {
        setLoading(false);
      }
    };

    checkClassRole();
  }, [currentUser]);

  return { isClassAdmin, classInfo, loading };
}